import { render, staticRenderFns } from "./textarea.vue?vue&type=template&id=34b34d13&scoped=true&"
import script from "./textarea.vue?vue&type=script&lang=js&"
export * from "./textarea.vue?vue&type=script&lang=js&"
import style0 from "./textarea.vue?vue&type=style&index=0&id=34b34d13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b34d13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34b34d13')) {
      api.createRecord('34b34d13', component.options)
    } else {
      api.reload('34b34d13', component.options)
    }
    module.hot.accept("./textarea.vue?vue&type=template&id=34b34d13&scoped=true&", function () {
      api.rerender('34b34d13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/textarea.vue"
export default component.exports